<div mat-dialog-content class="email">
  <mode-external-sharing
    [tooltipMessage]="sharingTooltip"
    [disabled]="sharingDisabled"
    [sharing]="sharing"
    (sharingChange)="sharingChange.emit($event)"
  ></mode-external-sharing>
  <form class="section email-form" [class.email-form-with-banner]="showExternalEmailBanner" [formGroup]="emailForm">
    <mode-email-settings-header></mode-email-settings-header>

    <div class="form-field mode-chips-input">
      <div class="label-container">
        <label class="mode-label" for="recipients">
          Recipients
          <span class="recipients-tally"> ({{ recipientsControl.length }}/{{ maxRecipients }}) </span>
        </label>
        <button
          class="clear-all"
          data-test="clear-all"
          [disabled]="!recipientsControl.length"
          (click)="recipientsControl.clear()"
        >
          Clear all
        </button>
      </div>
      <input
        class="mode-input"
        capraAutofocus
        id="recipients"
        placeholder="Add recipients by email"
        [disabled]="recipientsControl.length === maxRecipients"
        [matChipInputFor]="chipList"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addRecipient($event)"
        (paste)="pasteRecipient($event)"
      />
      <p
        *ngIf="recipientsControl.length === maxRecipients"
        class="mode-validation-error"
        data-test="max-recipients-message"
      >
        Maximum number of recipients reached
      </p>
      <p *ngIf="showInvalidEmailMessage" class="mode-validation-error">One or more email addresses are invalid</p>
      <p *ngIf="showExternalEmailMessage" class="mode-validation-error">
        One or more emails do not match your Workspace's claimed domain
      </p>
      <mat-chip-list
        #chipList
        class="mode-chips"
        formArrayName="recipients"
        multiple
        [style.maxHeight]="currentMaxHeight$ | async"
        [selectable]="false"
      >
        <mat-chip
          *ngFor="let recipient of recipientsControl.controls; trackBy: recipientsTrackByFn"
          [class.mode-chip-error]="
            sharing ? recipientErrors[recipient.value] === ErrorMessage.invalidEmail : !recipient.valid
          "
          [class.mode-chip-warning]="sharing ? recipientErrors[recipient.value] === ErrorMessage.claimedDomain : false"
          removable
          (removed)="removeRecipient(recipient.value)"
        >
          {{ recipient.value }}
          <capra-icon matChipRemove icon="icon-close"></capra-icon>
        </mat-chip>
      </mat-chip-list>
      <button *ngIf="showViewMoreButton$ | async" class="view-more" (click)="toggleRecipientsExpanded()">
        <ng-container *ngIf="viewButtonContent$ | async as content">
          <capra-icon
            class="arrow"
            [class.arrow-up]="content.direction === 'up'"
            [class.arrow-down]="content.direction === 'down'"
            icon="icon-back"
          ></capra-icon>
          {{ content.text }}
        </ng-container>
      </button>
    </div>
    <div class="form-field">
      <label class="mode-label" for="message"> Message </label>
      <textarea
        class="mode-textarea"
        id="message"
        formControlName="message"
        placeholder="Add a message (optional)"
      ></textarea>
    </div>
    <mode-email-settings
      [disableEmailAttachments]="emailAttachmentsDisabled"
      [selections]="selections"
      (selectionsChanged)="toggleEmailSettings($event)"
      data-test="email-settings"
    ></mode-email-settings>
  </form>
  <div *ngIf="showExternalEmailBanner" class="validation-banner">
    <capra-icon icon="icon-warning"> </capra-icon>
    One or more recipients are outside your Mode Workspace. They will have full access to the Report and underlying
    data.
  </div>
</div>
<div mat-dialog-actions>
  <capra-button
    *ngIf="schedulingEnabled"
    class="delivery-button"
    data-test="schedule-delivery"
    text="Set up a delivery schedule"
    variant="secondary"
    color="neutral"
    (clicked)="scheduleDelivery.emit()"
  ></capra-button>
  <capra-button text="Cancel" variant="secondary" color="neutral" (clicked)="cancel.emit()"></capra-button>
  <capra-button
    text="Send Email"
    data-test="send-email"
    [disabled]="!recipientsControl.length"
    (clicked)="sendEmail.emit(emailForm.value)"
  ></capra-button>
</div>
